"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePayInMethods = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useCache_1 = require("../useCache");
var useQuery_1 = require("../useQuery");
var CURRENT_COUNTRY = 'current_country';
var usePayInMethods = function (country) {
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.PAY_IN_METHODS,
        payload: {
            country: country,
        },
        canRender: !!country,
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading, mutate = _a.mutate;
    var _b = (0, useCache_1.useCache)(), getDataFromCache = _b.getDataFromCache, setDataToCache = _b.setDataToCache;
    (0, react_1.useEffect)(function () {
        var prevCountry = getDataFromCache(CURRENT_COUNTRY);
        if (!prevCountry || prevCountry !== country) {
            mutate();
            setDataToCache(CURRENT_COUNTRY, country);
        }
    }, [getDataFromCache, setDataToCache, country, mutate]);
    return (0, react_1.useMemo)(function () { return ({
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        error: error,
        payInMethods: mutate,
    }); }, [data, isLoading, error]);
};
exports.usePayInMethods = usePayInMethods;
